import React from "react";

const Skeleton = ({ height = 10, width = 40, className }) => {
  return (
    <div
      style={{ height: height + "px", width: width + "px" }}
      className={`bg-hover animate-pulse dark:bg-dark-hover rounded ${className}`}
    ></div>
  );
};

export default Skeleton;
